module.exports = __webpack_public_path__ + "img/course69.1c361d36.png";